import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import BookingPage from "@/pages/BookingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRentalsPage from "@/pages/AdminRentalsPage";
import BookingStatusPage from "@/pages/BookingStatusPage";
import InstructorEcardStore from "@/pages/InstructorEcardStore";
import OrderStatus from "@/pages/OrderStatus";
import WeeklyAvailability from "@/pages/WeeklyAvailability";
import POSPaymentPage from "@/pages/POSPaymentPage";
import RosterLookup from "@/pages/RosterLookup";
import ClassSignIn from "@/pages/ClassSignIn";
import InvoicePaymentPage from "@/pages/InvoicePaymentPage";
import CustomerInvoicePortal from "@/pages/CustomerInvoicePortal";
import EquipmentRentals from "@/pages/EquipmentRentals";
import RentalTracking from "@/pages/RentalTracking";
import ClientPortal from "@/pages/ClientPortal";
import ShopPage from "@/pages/ShopPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";

function App() {
  // Disable pull-to-refresh on mobile
  useEffect(() => {
    let lastTouchY = 0;
    
    const preventPullToRefresh = (e) => {
      const touchY = e.touches[0].clientY;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      
      // If at top of page and pulling down, prevent default
      if (scrollTop === 0 && touchY > lastTouchY) {
        e.preventDefault();
      }
      lastTouchY = touchY;
    };
    
    document.addEventListener('touchmove', preventPullToRefresh, { passive: false });
    
    return () => {
      document.removeEventListener('touchmove', preventPullToRefresh);
    };
  }, []);

  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BookingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/rentals" element={<AdminRentalsPage />} />
          <Route path="/booking-status/:bookingId" element={<BookingStatusPage />} />
          <Route path="/instructor-ecards" element={<InstructorEcardStore />} />
          <Route path="/order-status/:orderId" element={<OrderStatus />} />
          <Route path="/weekly-availability" element={<WeeklyAvailability />} />
          <Route path="/pos-payment/:orderId" element={<POSPaymentPage />} />
          <Route path="/roster" element={<RosterLookup />} />
          <Route path="/signin" element={<ClassSignIn />} />
          <Route path="/invoice/:invoiceId" element={<InvoicePaymentPage />} />
          <Route path="/my-invoices" element={<CustomerInvoicePortal />} />
          <Route path="/rentals" element={<EquipmentRentals />} />
          <Route path="/rental-tracking/:orderId" element={<RentalTracking />} />
          <Route path="/clients" element={<ClientPortal />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-left" />
    </div>
  );
}

export default App;